import { Resource } from '@models';

export interface ProjectResourceResult {
  projectResource: Resource[];
}
